// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconButton {
    align-self: center
}

/*.clearButton {
    cursor: pointer;
    margin-left: -8px;
    z-index: 1;
    background-color: white;
    height: 16px;
    border: 0px solid black;
    border-radius: 50%;
}
*/`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/controls/colorpicker/colorpicker.theme.control.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;;;;;;;;;CASC","sourcesContent":[".iconButton {\n    align-self: center\n}\n\n/*.clearButton {\n    cursor: pointer;\n    margin-left: -8px;\n    z-index: 1;\n    background-color: white;\n    height: 16px;\n    border: 0px solid black;\n    border-radius: 50%;\n}\n*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
